<div class="picker-header">Z ZAMÓWIENIA</div>

<input #inputElement placeholder="Pozycja, numer lub klient" (input)="onSearchChange($event.target.value)">

<div class="picker-separator"></div>

@if (state$ | async; as state) {
  @if (state.positions) {
    @if (state.positions.length === 0) {
      <div class="picker-empty">Brak otwartych pozycji</div>
    }

    <div class="picker-positions">
      @for (position of state.positions; track position.clientOrderItemId) {
        <div class="picker-position">
          <div class="picker-position-label" [title]="positionTitle(position)">
            <span class="picker-position-name">{{ position.name }}</span>
            <span class="picker-position-meta">· <span class="text-mono">{{ position.orderNumber }}</span> · {{ position.clientName }} · pozostało {{ formatAmount(position.remaining, position.unit) }}</span>
          </div>
          <input #amountInput class="picker-position-amount text-mono" type="text" inputmode="decimal" [value]="formatAmountInput(position.remaining)"
            (keyup.enter)="onAdd(position, amountInput.value)" title="Ile pozycji ma objąć to zlecenie">
          <button class="btn btn-small" (click)="onAdd(position, amountInput.value)">Dodaj</button>
        </div>
      }
    </div>
  }
}
